import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@givebutter/primitives/toast';
import Axios from 'api/client';
import { useAppState } from 'customHooks/useAppState';
import { GlobalAbortController } from 'helpers/abort-controller';
import { GivebutterAxiosError } from 'types/error';

const LogoutAbortController = new AbortController();

const useLogout = () => {
    const { error } = useToast();
    const queryClient = useQueryClient();
    const { apiUrl } = useAppState();

    const abortAndCancelQueries = () => {
        GlobalAbortController.abort();
        return queryClient.cancelQueries();
    };

    return useMutation({
        mutationFn: async () => {
            try {
                await Axios.post(`${apiUrl}/logout`, undefined, {
                    signal: LogoutAbortController.signal,
                });
                window.location.href = `${apiUrl}/login`;
                await abortAndCancelQueries();
            } catch (e) {
                error(
                    (e as GivebutterAxiosError).response?.data?.message ??
                        'Unable to logout. Please try again.',
                );
            }
        },
    });
};

export { useLogout };
